export class InstruccionRequest {

  ROUTE: string;
  PREFIJO_IDIOMA: string;
  ID_PASO: number;
  ID_CLIENTE: number;

  constructor() { }

}


export class Instruccion {

  constructor(public PREFIJO_IDIOMA?: string, public MENSAJE?: string, public NUM_PASO?: number) { }

  static toModel(json: string): Instruccion {
    if (json !== null && json !== 'null') {
      const data = JSON.parse(json);
      return new Instruccion(data.PREFIJO_IDIOMA, data.MENSAJE, data.NUM_PASO);
    }
    return null;
  }
}
